import React, { useEffect, useState } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { PostTimeline } from '../../Services/allApi';

function AddTimeline({ handleCloseModalTL, videoId }) {
    const [currentEntry, setCurrentEntry] = useState({
        start_time: '',
        end_time: '',
        description: '',
        language: 'English',
    });
    const [entryList, setEntryList] = useState([]);
    const handleInputChange = (field, value) => {
        setCurrentEntry({
            ...currentEntry,
            [field]: value
        });
    };
    const handleAddEntry = () => {
        if (currentEntry.start_time && currentEntry.end_time && currentEntry.description && currentEntry.language) {
            setEntryList([...entryList, currentEntry]);
            setCurrentEntry({
                start_time: '',
                end_time: '',
                description: '',
                language: 'English'
            });
        } else {
            toast.warning("Fill the form completely to add");
        }
    };
    const handleInputChangeList = (index, field, value) => {
        const newEntryList = [...entryList];
        newEntryList[index][field] = value;
        setEntryList(newEntryList);
    };
    const handleRemoveEntry = (index) => {
        const newEntryList = entryList.filter((_, i) => i !== index);
        setEntryList(newEntryList);
    };
    const handleSubmit = async () => {
        const token = sessionStorage.getItem('access_token');
        const reqHeader = {
            "Content-Type": "application/json",
            "Authorization": `${token}`
        };
        const modifiedSittingsList = {
            video_id: videoId,
            srt_data: entryList.map(item => ({
                start_time: item.start_time,
                end_time: item.end_time,
                description: item.description,
                language: item.language == 'English' ? 1 : 2,
            }))
        };
        console.log(JSON.stringify(modifiedSittingsList, null, 2));
        const res = await PostTimeline(modifiedSittingsList, reqHeader);
        console.log(res);
        handleCloseModalTL();
    };

    return (
        <>
            <div className='flex w-full h-full flex-row' style={{ height: '86vh' }}>
                <div className='w-full flex items-center flex-col overflow-y-scroll overflow-x-hidden' style={{ height: '87vh' }}>
                    <div className='flex flex-row justify-center flex-wrap ms-5 me-5 gap-1 w-full '>
                        <div className='flex flex-col w-full gap-5'>
                            <div className='bg-success px-4 py-2 rounded border'>
                                <h3 className='text-blue-700 text-xl font-bold mb-4 text-center'>Add Sittings</h3>
                                <div className='flex flex-row justify-center flex-wrap mb-5'>
                                    <div className='w-2/12 flex flex-col me-5'>
                                        <label>Start Time</label>
                                        <input
                                            type='number'
                                            value={currentEntry.start_time}
                                            onChange={(e) => handleInputChange('start_time', e.target.value)}
                                            className='w-full h-10 rounded-lg border border-gray-700 px-2'
                                        />
                                    </div>
                                    <div className='w-2/12 flex flex-col me-5'>
                                        <label>End Time</label>
                                        <input
                                            type='number'
                                            value={currentEntry.end_time}
                                            onChange={(e) => handleInputChange('end_time', e.target.value)}
                                            className='w-full h-10 rounded-lg border border-gray-700 px-2'
                                        />
                                    </div>
                                    <div className='w-3/12 flex flex-col me-5'>
                                        <label>Description</label>
                                        <input
                                            type="text"
                                            value={currentEntry.description}
                                            onChange={(e) => handleInputChange('description', e.target.value)}
                                            className='w-full h-10 rounded-lg border border-gray-700 px-2'
                                        />
                                    </div>
                                    <div className='w-2/12 flex flex-col me-5'>
                                        <label>Language</label>
                                        <select
                                            value={currentEntry.language}
                                            onChange={(e) => handleInputChange('language', e.target.value)}
                                            className='w-full h-10 rounded-lg border border-gray-700 px-2'>
                                            <option value="English">English</option>
                                            <option value="Malayalam">Malayalam</option>
                                        </select>
                                    </div>
                                    <div className='w-2/12 flex flex-col ms-5'>
                                        <label style={{ visibility: 'hidden' }}>Add</label>
                                        <button className='w-full py-2 rounded-lg bg-green-500 text-white mb-3' onClick={handleAddEntry}>
                                            Add
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='w-full flex flex-col gap-4 mt-4'>
                        {entryList.map((entry, index) => (
                            <div key={index} className='bg-gray-200 px-4 py-2 rounded border'>
                                <h3 className='text-gray-700 text-sm text-left'>No {index + 1}</h3>
                                <div className='flex flex-row justify-center flex-wrap mb-1'>
                                    <div className='w-2/12 flex flex-col me-5'>
                                        <label>Start Time</label>
                                        <input
                                            type='number'
                                            value={entry.start_time}
                                            onChange={(e) => handleInputChangeList(index, 'start_time', e.target.value)}
                                            className='w-full h-10 rounded-lg border border-gray-700 px-2'
                                        />
                                    </div>
                                    <div className='w-2/12 flex flex-col me-5'>
                                        <label>End Time</label>
                                        <input
                                            type='number'
                                            value={entry.end_time}
                                            onChange={(e) => handleInputChangeList(index, 'end_time', e.target.value)}
                                            className='w-full h-10 rounded-lg border border-gray-700 px-2'
                                        />
                                    </div>
                                    <div className='w-3/12 flex flex-col me-5'>
                                        <label>Description</label>
                                        <input
                                            type="text"
                                            value={entry.description}
                                            onChange={(e) => handleInputChangeList(index, 'description', e.target.value)}
                                            className='w-full h-10 rounded-lg border border-gray-700 px-2'
                                        />
                                    </div>
                                    <div className='w-2/12 flex flex-col me-5'>
                                        <label>Language</label>
                                        <select
                                            value={entry.language}
                                            onChange={(e) => handleInputChangeList(index, 'language', e.target.value)}
                                            className='w-full h-10 rounded-lg border border-gray-700 px-2'
                                        >
                                            <option value="English">English</option>
                                            <option value="Malayalam">Malayalam</option>
                                        </select>
                                    </div>
                                    <div className='w-2/12 flex flex-col ms-5'>
                                        <label style={{ visibility: 'hidden' }}>Remove</label>
                                        <button className='w-full py-2 rounded-lg bg-red-500 text-white mb-3' onClick={() => handleRemoveEntry(index)}>
                                            Remove
                                        </button>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                    <div className='flex flex-row justify-center gap-5 w-full'>
                        {entryList.length > 0 && (
                            <div className='w-2/12'>
                                <button className='w-full py-2 mt-20 text-white rounded-full bg-primary' onClick={handleSubmit}>
                                    Submit
                                </button>
                            </div>
                        )}
                        <div className='w-2/12'>
                            <button className='w-full py-2 mt-20 rounded-full text-red-500 bg-success border' onClick={handleCloseModalTL}>
                                Cancel
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <ToastContainer
                position="top-center"
                autoClose={4000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                draggable
                pauseOnHover
                theme="light"
            />
        </>
    );
}

export default AddTimeline;
